/* eslint-disable consistent-return */
import React from 'react';
import './css/CurrencySelector.css';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  CURRENCY,
  BYN_TEXT,
  USD_TEXT,
  EUR_TEXT,
  RUB_TEXT,
} from '../../Utils/Constants/GlobalConstants';
import { ReactComponent as BYN_ICO } from '../../images/byn.svg';
import { ReactComponent as USD_ICO } from '../../images/usd.svg';
import { ReactComponent as EUR_ICO } from '../../images/eur.svg';
import { ReactComponent as RUB_ICO } from '../../images/rub.svg';
import { countries } from '../../Utils/Constants/countries';

const mapStateToProps = (state) => ({ ...state });

class CurrencySelector extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isCurrencyPopupVisible: false,
    };
  }

  handleSelect = (currencyId) => {
    const { handleCurrency } = this.props;

    this.handleClick();
    handleCurrency(currencyId);
  };

  getCurrOptions = () => {
    const result = [];

    const { destination } = this.props;
    const desCountry = countries.filter((e) => e.id === destination.id);

    if (desCountry.length === 1) {
      const { isUsd } = desCountry[0];

      result.push(
        <button
          key={`curr-${2}`}
          type="button"
          onClick={() => this.handleSelect(2)}
          className="currencies_popup_but"
        >
          <BYN_ICO className="c_curr_ico" />
          <div>{BYN_TEXT}</div>
        </button>,
      );

      if (isUsd) {
        result.push(
          <button
            key={`curr-${1}usd`}
            type="button"
            onClick={() => this.handleSelect(1)}
            className="currencies_popup_but"
          >
            <USD_ICO className="c_curr_ico" />
            <div>{USD_TEXT}</div>
          </button>,
        );
      } else {
        result.push(
          <button
            key={`curr-${1}eur`}
            type="button"
            onClick={() => this.handleSelect(1)}
            className="currencies_popup_but"
          >
            <EUR_ICO className="c_curr_ico" />
            <div>{EUR_TEXT}</div>
          </button>,
        );
      }

      result.push(
        <button
          key={`curr-${0}`}
          type="button"
          onClick={() => this.handleSelect(0)}
          className="currencies_popup_but"
        >
          <RUB_ICO className="c_curr_ico" />
          <div>{RUB_TEXT}</div>
        </button>,
      );
    }

    return result;
  };

  getCurrencyName = () => {
    const { currency, destination } = this.props;
    const desCountry = countries.filter((e) => e.id === destination.id);

    if (desCountry.length === 1) {
      const { isUsd } = desCountry[0];

      if (currency.id === 0) {
        return (
          <div className="c_currency_line">
            <RUB_ICO className="c_currency_ico" />
            <div>{RUB_TEXT}</div>
          </div>
        );
      } else if (currency.id === 1) {
        if (isUsd) {
          return (
            <div className="c_currency_line">
              <USD_ICO className="c_currency_ico" />
              <div>{USD_TEXT}</div>
            </div>
          );
        } else {
          return (
            <div className="c_currency_line">
              <EUR_ICO className="c_currency_ico" />
              <div>{EUR_TEXT}</div>
            </div>
          );
        }
      } else {
        return (
          <div className="c_currency_line">
            <BYN_ICO className="c_currency_ico" />
            <div>{BYN_TEXT}</div>
          </div>
        );
      }
    }
  };

  handleClick = () => {
    const { isCurrencyPopupVisible } = this.state;
    if (!isCurrencyPopupVisible) {
      document.addEventListener('click', this.handleOutsideClick, false);
    } else {
      document.removeEventListener('click', this.handleOutsideClick, false);
    }

    this.setState({ isCurrencyPopupVisible: !isCurrencyPopupVisible });
  };

  handleOutsideClick = (e) => {
    if (this.currencyNode.contains(e.target)) {
      return;
    }

    this.handleClick();
  };

  render() {
    const { isCurrencyPopupVisible } = this.state;

    return (
      <div
        className="c_currency_w"
        ref={(node) => {
          this.currencyNode = node;
        }}
      >
        <div>{`${CURRENCY}:`}</div>
        <button
          type="button"
          className="c_currency_button"
          onClick={this.handleClick}
        >
          {this.getCurrencyName()}
        </button>
        {isCurrencyPopupVisible && (
          <div className="currencies_popup_w">{this.getCurrOptions()}</div>
        )}
      </div>
    );
  }
}

CurrencySelector.propTypes = {
  destination: PropTypes.instanceOf(Object).isRequired,
  currency: PropTypes.instanceOf(Object).isRequired,
  handleCurrency: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, {})(CurrencySelector);
